<template>
  <main class="">
    <aos-vue>
      <section class="px-4">
        <div
          data-aos="fade-up"
          class="mb-4 rounded-8vw col-lg-12 mr-auto pb-3 bg-white rounded"
        >
          <div class="d-flex gap-2-2vw mx-0 align-items-start p-4">
            <form class="col-8 flex-grow-1 flex-shrink-0 z-10 flex-row">
              <div class="d-flex flex-row gap-4vw">
                <div
                  class="d-flex flex-column w-100 gap-1vw align-items-center justify-content-center"
                >
                  <div class="row mx-0 w-100 align-items-center">
                    <label class="col-7 px-0 fs-1-2vw text-white fw-bold"
                      >1-ﺍﻗﺘﺼﺎﺩی ﺑﻮﺩﻥ ﺍﻧﺪﺍﺯﻩ را چطور ارزیابی می کنید؟</label
                    >
                    <div class="col-1"></div>
                    <div
                      style="width: 12vw"
                      class="d-flex px-0 align-items-center justify-content-between gap-1 border-b-info-3 text-center radioLabel pb-3 text-info"
                    >
                      <p class="mb-0">غیرجذاب</p>
                      <p class="mb-0">
                        غیرجذاب<br />
                        متوسط
                      </p>
                      <p class="mb-0">بی تفاوت</p>
                      <p class="mb-0">
                        جذاب<br />
                        متوسط
                      </p>
                      <p class="mb-0">جذاب</p>
                    </div>
                  </div>
                  <div class="row mx-0 w-100 align-items-center">
                    <label class="col-7 px-0 fs-1-2vw text-dark fw-bold"
                    >1-ﺍﻗﺘﺼﺎﺩی ﺑﻮﺩﻥ ﺍﻧﺪﺍﺯﻩ را چطور ارزیابی می کنید؟</label
                    >
                    <div class="col-1"></div>
                    <div
                      style="width: 12vw"
                      class="px-0 d-flex align-items-center justify-content-between gap-2 position-relative fs-1vw"
                    >
                      <p
                        class="mb-0 fw-bold text-danger -right-3vw position-absolute w-3vw"
                      >
                        کوچک
                      </p>
                      <div class="flex-grow-1">
                        <div
                          class="d-flex align-items-center justify-content-between gap-04vw border rounded-0-4vw border-dark p-1 inputBox"
                        >
                          <div
                            v-for="(n, index) in 5"
                            :key="index"
                            :class="{ active: selectedOption === n }"
                            class="position-relative border rounded-0-4vw border-dark bg-secondary w-1-5vw h-1-5vw flex-grow-1 d-flex align-items-center justify-content-center"
                          >
                            <input
                              :value="n"
                              v-model="selectedOption"
                              @change="updateChartData(index + 1)"
                              type="radio"
                              name="radio"
                              class="position-absolute opacity-none top-0 end-0 bottom-0 start-0 w-100 h-100 cursor-pointer"
                            />
                            {{ n }}
                          </div>
                        </div>
                      </div>
                      <p
                        class="mb-0 fw-bold text-success position-absolute w-3vw -left-3vw"
                      >
                        بزرگ
                      </p>
                    </div>
                  </div>
                  <div class="row mx-0 w-100 align-items-center">
                    <label class="col-7 px-0 fs-1-2vw text-dark fw-bold"
                      >2-تنوع محصول را چطور ارزیابی می کنید؟</label
                    >
                    <div class="col-1"></div>
                    <div
                      style="width: 12vw"
                      class="px-0 d-flex align-items-center justify-content-between gap-2 position-relative fs-1vw"
                    >
                      <p
                        class="mb-0 fw-bold text-danger -right-3vw position-absolute w-3vw"
                      >
                        کم
                      </p>
                      <div class="flex-grow-1">
                        <div
                          class="d-flex align-items-center justify-content-between gap-04vw border rounded-0-4vw border-dark p-1 inputBox"
                        >
                          <div
                            v-for="(n, index) in 5"
                            :key="index"
                            :class="{ active: selectedOption2 === n }"
                            class="position-relative border rounded-0-4vw border-dark bg-secondary w-1-5vw h-1-5vw flex-grow-1 d-flex align-items-center justify-content-center"
                          >
                            <input
                              :value="n"
                              v-model="selectedOption2"
                              @change="updateChartData2(index + 1)"
                              type="radio"
                              name="radio"
                              class="position-absolute opacity-none top-0 end-0 bottom-0 start-0 w-100 h-100 cursor-pointer"
                            />
                            {{ n }}
                          </div>
                        </div>
                      </div>
                      <p
                        class="mb-0 fw-bold text-success position-absolute w-3vw -left-3vw"
                      >
                        زیاد
                      </p>
                    </div>
                  </div>
                  <div class="row mx-0 w-100 align-items-center">
                    <label class="col-7 px-0 fs-1-2vw text-dark fw-bold"
                    >3-معروفیت نام تجاری را چطور ارزیابی می کنید؟</label
                    >
                    <div class="col-1"></div>
                    <div
                      style="width: 12vw"
                      class="px-0 d-flex align-items-center justify-content-between gap-2 position-relative fs-1vw"
                    >
                      <p
                        class="mb-0 fw-bold text-danger -right-3vw position-absolute w-3vw"
                      >
                        پایین
                      </p>
                      <div class="flex-grow-1">
                        <div
                          class="d-flex align-items-center justify-content-between gap-04vw border rounded-0-4vw border-dark p-1 inputBox"
                        >
                          <div
                            v-for="(n, index) in 5"
                            :key="index"
                            :class="{ active: selectedOption3 === n }"
                            class="position-relative border rounded-0-4vw border-dark bg-secondary w-1-5vw h-1-5vw flex-grow-1 d-flex align-items-center justify-content-center"
                          >
                            <input
                              :value="n"
                              v-model="selectedOption3"
                              @change="updateChartData3(index + 1)"
                              type="radio"
                              name="radio"
                              class="position-absolute opacity-none top-0 end-0 bottom-0 start-0 w-100 h-100 cursor-pointer"
                            />
                            {{ n }}
                          </div>
                        </div>
                      </div>
                      <p
                        class="mb-0 fw-bold text-success position-absolute w-3vw -left-3vw"
                      >
                        بالا
                      </p>
                    </div>
                  </div>
                  <div class="row mx-0 w-100 align-items-center">
                    <label class="col-7 px-0 fs-1-2vw text-dark fw-bold"
                    >4-هزینه تغییر کاربری را چطور ارزیابی می کنید؟</label
                    >
                    <div class="col-1"></div>
                    <div
                      style="width: 12vw"
                      class="px-0 d-flex align-items-center justify-content-between gap-2 position-relative fs-1vw"
                    >
                      <p
                        class="mb-0 fw-bold text-danger -right-3vw position-absolute w-3vw"
                      >
                        پایین
                      </p>
                      <div class="flex-grow-1">
                        <div
                          class="d-flex align-items-center justify-content-between gap-04vw border rounded-0-4vw border-dark p-1 inputBox"
                        >
                          <div
                            v-for="(n, index) in 5"
                            :key="index"
                            :class="{ active: selectedOption4 === n }"
                            class="position-relative border rounded-0-4vw border-dark bg-secondary w-1-5vw h-1-5vw flex-grow-1 d-flex align-items-center justify-content-center"
                          >
                            <input
                              :value="n"
                              v-model="selectedOption4"
                              @change="updateChartData4(index + 1)"
                              type="radio"
                              name="radio"
                              class="position-absolute opacity-none top-0 end-0 bottom-0 start-0 w-100 h-100 cursor-pointer"
                            />
                            {{ n }}
                          </div>
                        </div>
                      </div>
                      <p
                        class="mb-0 fw-bold text-success position-absolute w-3vw -left-3vw"
                      >
                        بالا
                      </p>
                    </div>
                  </div>
                  <div class="row mx-0 w-100 align-items-center">
                    <label class="col-7 px-0 fs-1-2vw text-dark fw-bold"
                    >5-دسترسی به مجاری توزیع را چطور ارزیابی می کنید؟</label
                    >
                    <div class="col-1"></div>
                    <div
                      style="width: 12vw"
                      class="px-0 d-flex align-items-center justify-content-between gap-2 position-relative fs-1vw"
                    >
                      <p
                        class="mb-0 fw-bold text-danger -right-3vw position-absolute w-3vw"
                      >
                        فراوان
                      </p>
                      <div class="flex-grow-1">
                        <div
                          class="d-flex align-items-center justify-content-between gap-04vw border rounded-0-4vw border-dark p-1 inputBox"
                        >
                          <div
                            v-for="(n, index) in 5"
                            :key="index"
                            :class="{ active: selectedOption5 === n }"
                            class="position-relative border rounded-0-4vw border-dark bg-secondary w-1-5vw h-1-5vw flex-grow-1 d-flex align-items-center justify-content-center"
                          >
                            <input
                              :value="n"
                              v-model="selectedOption5"
                              @change="updateChartData5(index + 1)"
                              type="radio"
                              name="radio"
                              class="position-absolute opacity-none top-0 end-0 bottom-0 start-0 w-100 h-100 cursor-pointer"
                            />
                            {{ n }}
                          </div>
                        </div>
                      </div>
                      <p
                        class="mb-0 fw-bold text-success position-absolute w-3vw -left-3vw"
                      >
                        محدود
                      </p>
                    </div>
                  </div>
                  <div class="row mx-0 w-100 align-items-center">
                    <label class="col-7 px-0 fs-1-2vw text-dark fw-bold"
                    >6-نیاز به سرمایه را چطور ارزیابی می کنید؟</label
                    >
                    <div class="col-1"></div>
                    <div
                      style="width: 12vw"
                      class="px-0 d-flex align-items-center justify-content-between gap-2 position-relative fs-1vw"
                    >
                      <p
                        class="mb-0 fw-bold text-danger -right-3vw position-absolute w-3vw"
                      >
                        پایین
                      </p>
                      <div class="flex-grow-1">
                        <div
                          class="d-flex align-items-center justify-content-between gap-04vw border rounded-0-4vw border-dark p-1 inputBox"
                        >
                          <div
                            v-for="(n, index) in 5"
                            :key="index"
                            :class="{ active: selectedOption6 === n }"
                            class="position-relative border rounded-0-4vw border-dark bg-secondary w-1-5vw h-1-5vw flex-grow-1 d-flex align-items-center justify-content-center"
                          >
                            <input
                              :value="n"
                              v-model="selectedOption6"
                              @change="updateChartData6(index + 1)"
                              type="radio"
                              name="radio"
                              class="position-absolute opacity-none top-0 end-0 bottom-0 start-0 w-100 h-100 cursor-pointer"
                            />
                            {{ n }}
                          </div>
                        </div>
                      </div>
                      <p
                        class="mb-0 fw-bold text-success position-absolute w-3vw -left-3vw"
                      >
                        بالا
                      </p>
                    </div>
                  </div>
                  <div class="row mx-0 w-100 align-items-center">
                    <label class="col-7 px-0 fs-1-2vw text-dark fw-bold"
                    >7-دسترسی به آخرین تکنولوژی را چطور ارزیابی می کنید؟</label
                    >
                    <div class="col-1"></div>
                    <div
                      style="width: 12vw"
                      class="px-0 d-flex align-items-center justify-content-between gap-2 position-relative fs-1vw"
                    >
                      <p
                        class="mb-0 fw-bold text-danger -right-3vw position-absolute w-3vw"
                      >
                        فراوان
                      </p>
                      <div class="flex-grow-1">
                        <div
                          class="d-flex align-items-center justify-content-between gap-04vw border rounded-0-4vw border-dark p-1 inputBox"
                        >
                          <div
                            v-for="(n, index) in 5"
                            :key="index"
                            :class="{ active: selectedOption7 === n }"
                            class="position-relative border rounded-0-4vw border-dark bg-secondary w-1-5vw h-1-5vw flex-grow-1 d-flex align-items-center justify-content-center"
                          >
                            <input
                              :value="n"
                              v-model="selectedOption7"
                              @change="updateChartData7(index + 1)"
                              type="radio"
                              name="radio"
                              class="position-absolute opacity-none top-0 end-0 bottom-0 start-0 w-100 h-100 cursor-pointer"
                            />
                            {{ n }}
                          </div>
                        </div>
                      </div>
                      <p
                        class="mb-0 fw-bold text-success position-absolute w-3vw -left-3vw"
                      >
                        محدود
                      </p>
                    </div>
                  </div>
                  <div class="row mx-0 w-100 align-items-center">
                    <label class="col-7 px-0 fs-1-2vw text-dark fw-bold"
                    >8-دسترسی به مواد خام را چطور ارزیابی می کنید؟</label
                    >
                    <div class="col-1"></div>
                    <div
                      style="width: 12vw"
                      class="px-0 d-flex align-items-center justify-content-between gap-2 position-relative fs-1vw"
                    >
                      <p
                        class="mb-0 fw-bold text-danger -right-3vw position-absolute w-3vw"
                      >
                        فراوان
                      </p>
                      <div class="flex-grow-1">
                        <div
                          class="d-flex align-items-center justify-content-between gap-04vw border rounded-0-4vw border-dark p-1 inputBox"
                        >
                          <div
                            v-for="(n, index) in 5"
                            :key="index"
                            :class="{ active: selectedOption8 === n }"
                            class="position-relative border rounded-0-4vw border-dark bg-secondary w-1-5vw h-1-5vw flex-grow-1 d-flex align-items-center justify-content-center"
                          >
                            <input
                              :value="n"
                              v-model="selectedOption8"
                              @change="updateChartData8(index + 1)"
                              type="radio"
                              name="radio"
                              class="position-absolute opacity-none top-0 end-0 bottom-0 start-0 w-100 h-100 cursor-pointer"
                            />
                            {{ n }}
                          </div>
                        </div>
                      </div>
                      <p
                        class="mb-0 fw-bold text-success position-absolute w-3vw -left-3vw"
                      >
                        محدود
                      </p>
                    </div>
                  </div>
                  <div class="row mx-0 w-100 align-items-center">
                    <label class="col-7 px-0 fs-1-2vw text-dark fw-bold"
                    >9-حمایت دولت را چطور ارزیابی می کنید؟</label
                    >
                    <div class="col-1"></div>
                    <div
                      style="width: 12vw"
                      class="px-0 d-flex align-items-center justify-content-between gap-2 position-relative fs-1vw"
                    >
                      <p
                        class="mb-0 fw-bold text-danger -right-3vw position-absolute w-3vw"
                      >
                        زیاد
                      </p>
                      <div class="flex-grow-1">
                        <div
                          class="d-flex align-items-center justify-content-between gap-04vw border rounded-0-4vw border-dark p-1 inputBox"
                        >
                          <div
                            v-for="(n, index) in 5"
                            :key="index"
                            :class="{ active: selectedOption9 === n }"
                            class="position-relative border rounded-0-4vw border-dark bg-secondary w-1-5vw h-1-5vw flex-grow-1 d-flex align-items-center justify-content-center"
                          >
                            <input
                              :value="n"
                              v-model="selectedOption9"
                              @change="updateChartData9(index + 1)"
                              type="radio"
                              name="radio"
                              class="position-absolute opacity-none top-0 end-0 bottom-0 start-0 w-100 h-100 cursor-pointer"
                            />
                            {{ n }}
                          </div>
                        </div>
                      </div>
                      <p
                        class="mb-0 fw-bold text-success position-absolute w-3vw -left-3vw"
                      >
                        کمیاب
                      </p>
                    </div>
                  </div>
                  <div class="row mx-0 w-100 align-items-center">
                    <label class="col-7 px-0 fs-1-2vw text-dark fw-bold"
                    >10-اثر تجربه و یادگیری را چطور ارزیابی می کنید؟</label
                    >
                    <div class="col-1"></div>
                    <div
                      style="width: 12vw"
                      class="px-0 d-flex align-items-center justify-content-between gap-2 position-relative fs-1vw"
                    >
                      <p
                        class="mb-0 fw-bold text-danger -right-3vw position-absolute w-3vw"
                      >
                        اهمیت کم
                      </p>
                      <div class="flex-grow-1">
                        <div
                          class="d-flex align-items-center justify-content-between gap-04vw border rounded-0-4vw border-dark p-1 inputBox"
                        >
                          <div
                            v-for="(n, index) in 5"
                            :key="index"
                            :class="{ active: selectedOption10 === n }"
                            class="position-relative border rounded-0-4vw border-dark bg-secondary w-1-5vw h-1-5vw flex-grow-1 d-flex align-items-center justify-content-center"
                          >
                            <input
                              :value="n"
                              v-model="selectedOption10"
                              @change="updateChartData10(index + 1)"
                              type="radio"
                              name="radio"
                              class="position-absolute opacity-none top-0 end-0 bottom-0 start-0 w-100 h-100 cursor-pointer"
                            />
                            {{ n }}
                          </div>
                        </div>
                      </div>
                      <p
                        class="mb-0 fw-bold text-success position-absolute w-3vw -left-3vw"
                      >
                        اهمیت زیاد
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div
              class="mt-5 d-flex align-items-start"
              style="transform: translateX(11vw) translateY(-4vw)"
            >
              <apexchart
                style="width: 40vw"
                type="radar"
                :options="options"
                :series="series"
              ></apexchart>
            </div>
          </div>
          <center class="p-2">
            <hr class="mt-2 mb-2" />
            <button
              @click="showData"
              class="btn btn-primary py-3 btn-submit-1 x mt-4"
            >
              ذخیره
            </button>
          </center>
        </div>
      </section>
    </aos-vue>
  </main>
</template>
  

<script>
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  props: {
    name: {
      type: String,
      require: true,
    },
    id_item: {
      type: Number,
      required: true,
    },
  },
  methods: {
    showData() {
      let q1 = this.series[0].data[0];
      let q2 = this.series[0].data[1];
      let q3 = this.series[0].data[2];
      let q4 = this.series[0].data[3];
      let q5 = this.series[0].data[4];
      let q6 = this.series[0].data[5];
      let q7 = this.series[0].data[6];
      let q8 = this.series[0].data[7];
      let q9 = this.series[0].data[8];
      let q10 = this.series[0].data[9];
      if (!q1) {
        toast.error("سوال شماره 1 اجباری است!");
        return;
      } else if (!q2) {
        toast.error("سوال شماره 2 اجباری است!");
        return;
      } else if (!q3) {
        toast.error("سوال شماره 3 اجباری است!");
        return;
      } else if (!q4) {
        toast.error("سوال شماره 4 اجباری است!");
        return;
      } else if (!q5) {
        toast.error("سوال شماره 5 اجباری است!");
        return;
      } else if (!q6) {
        toast.error("سوال شماره 6 اجباری است!");
        return;
      } else if (!q7) {
        toast.error("سوال شماره 7 اجباری است!");
        return;
      } else if (!q8) {
        toast.error("سوال شماره 8 اجباری است!");
        return;
      } else if (!q9) {
        toast.error("سوال شماره 9 اجباری است!");
        return;
      } else if (!q10) {
        toast.error("سوال شماره 10 اجباری است!");
        return;
      }

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get("token")}`);

      var formdata = new FormData();
      formdata.append("q_1", parseInt(q1));
      formdata.append("q_2", parseInt(q2));
      formdata.append("q_3", parseInt(q3));
      formdata.append("q_4", parseInt(q4));
      formdata.append("q_5", parseInt(q5));
      formdata.append("q_6", parseInt(q6));
      formdata.append("q_7", parseInt(q7));
      formdata.append("q_8", parseInt(q8));
      formdata.append("q_9", parseInt(q9));
      formdata.append("q_10", parseInt(q10));
      formdata.append("basic_id", this.id_item);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };
      fetch(
        `${this.base_url}/BasicDefinitionsFiveF/store_newcomers`,
        requestOptions
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.message) {
            toast.success(response.message);
          }
        })
        .catch();
    },
    fetchAll() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get("token")}`);
      var formdata = new FormData();
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };
      fetch(
        `${this.base_url}/BasicDefinitionsFiveF/show_newcomers/${this.id_item}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.item) {
            this.series[0].data[0] = response.item.q_1;
            this.series[0].data[1] = response.item.q_2;
            this.series[0].data[2] = response.item.q_3;
            this.series[0].data[3] = response.item.q_4;
            this.series[0].data[4] = response.item.q_5;
            this.series[0].data[5] = response.item.q_6;
            this.series[0].data[6] = response.item.q_7;
            this.series[0].data[7] = response.item.q_8;
            this.series[0].data[8] = response.item.q_9;
            this.series[0].data[9] = response.item.q_10;
            this.selectedOption = response.item.q_1;
            this.selectedOption2 = response.item.q_2;
            this.selectedOption3 = response.item.q_3;
            this.selectedOption4 = response.item.q_4;
            this.selectedOption5 = response.item.q_5;
            this.selectedOption6 = response.item.q_6;
            this.selectedOption7 = response.item.q_7;
            this.selectedOption8 = response.item.q_8;
            this.selectedOption9 = response.item.q_9;
            this.selectedOption10 = response.item.q_10;
          }
        })
        .catch();
    },
    updateChartData(index) {
      this.selectedOption = index;
      this.series[0].data[0] = index;
    },
    updateChartData2(index) {
      this.selectedOption2 = index;
      this.series[0].data[1] = index;
    },
    updateChartData3(index) {
      this.selectedOption3 = index;
      this.series[0].data[2] = index;
    },
    updateChartData4(index) {
      this.selectedOption4 = index;
      this.series[0].data[3] = index;
    },
    updateChartData5(index) {
      this.selectedOption5 = index;
      this.series[0].data[4] = index;
    },
    updateChartData6(index) {
      this.selectedOption6 = index;
      this.series[0].data[5] = index;
    },
    updateChartData7(index) {
      this.selectedOption7 = index;
      this.series[0].data[6] = index;
    },
    updateChartData8(index) {
      this.selectedOption8 = index;
      this.series[0].data[7] = index;
    },
    updateChartData9(index) {
      this.selectedOption9 = index;
      this.series[0].data[8] = index;
    },
    updateChartData10(index) {
      this.selectedOption10 = index;
      this.series[0].data[9] = index;
    },
  },
  data: function () {
    return {
      selectedOption: 0,
      selectedOption2: 0,
      selectedOption3: 0,
      selectedOption4: 0,
      selectedOption5: 0,
      selectedOption6: 0,
      selectedOption7: 0,
      selectedOption8: 0,
      selectedOption9: 0,
      selectedOption10: 0,
      options: {
        markers: {
          size: 5,
          hover: {
            size: 10,
          },
        },
        fill: {
          opacity: 0.2,
          colors: ["#3c76f2"],
        },
        plotOptions: {
          radar: {
            polygons: {
              strokeColor: "#e8e8e8",
              fill: {
                colors: ["#f5f4f8", "#fff"],
              },
            },
          },
        },
        xaxis: {
          categories: [
            "ﺍﻗﺘﺼﺎﺩی ﺑﻮﺩﻥ ﺍﻧﺪﺍﺯﻩ",
            "تنوع محصول",
            "معروفیت نام تجاری",
            "هزینه تغییر کاربری",
            "ﺩﺳﺘﺮﺳی ﺑﻪ ﻣﺠﺎﺭی ﺗﻮﺯﯾﻊ",
            "ﻧﯿﺎﺯ ﺑﻪ ﺳﺮﻣﺎﯾﻪ",
            "ﺩﺳﺘﺮﺳی ﺑﻪﺁﺧﺮﯾﻦ ﺗکﻨﻮﻟﻮژی",
            "ﺩﺳﺘﺮﺳی ﺑﻪ ﻣﻮﺍﺩ ﺧﺎﻡ",
            "ﺣﻤﺎﯾﺖﺩﻭﻟﺖ",
            "ﺍﺛﺮ ﺗﺠﺮﺑﻪ ﻭ ﯾﺎﺩگﯿﺮی",
          ],
          labels: {
            show: true,
            style: {
              colors: [
                "#000000",
                "#000000",
                "#000000",
                "#000000",
                "#000000",
                "#000000",
                "#000000",
                "#000000",
                "#000000",
                "#000000",
              ],
              fontFamily: "shabnam",
            },
          },
        },
      },
      series: [
        {
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
    };
  },
  mounted() {
    this.fetchAll();
  },
};
</script>

<style lang="scss" scoped>
p {
  font-size: 0.7vw !important;
}
label {
  text-align: right;
  font-size: 0.9vw !important;
}
input {
  z-index: 999999999999999999999999999999999999999999 !important;
}
.inputBox {
  width: 12vw !important;
}
</style>